import React from 'react';
import { injectIntl } from 'react-intl';

const ValidationMessage = (props) => {
  let { message, show, intl } = props;

  if (!show || !message) {
    return null;
  }

  if (message && message.id && intl) {
    message = intl.formatMessage(message);
  }

  return (
    <span className="small text">{message}</span>
  );
}

export default injectIntl(ValidationMessage);